











import { Component, Vue } from 'vue-property-decorator';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import {templateListInstance} from '@/model/ModuleTemplateListClass';
import CreateTemplateForm from './components/createTemplateForm.vue';

type IModuleTemplateParams = IModule.IRequest.IModuleTemplateParams;

@Component({
  components: {
    CreateTemplateForm,
  },
})
export default class UpdateTemplate extends Vue {
  private templateListInstance = templateListInstance;
  get template() {
    return this.templateListInstance.editItem;
  }
  private changeTemplate(params: IModuleTemplateParams): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.template) {
        reject('Error');
        return;
      }
      this.templateListInstance.requestUpdateTemplate(params).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
}
